module.exports = __webpack_public_path__ + "static/media/watermark.4c79bea4.jpg";